module.exports = __webpack_public_path__ + "a7ba55af79203379cf2325e33d3dc7a6.svg";